export interface InputFieldOptions {
    required?: boolean;
    type?: string;
    param?: any;
}

export function InputField(inputFieldOptions?: InputFieldOptions) {

    return function (target: Object, propertyKey: string | symbol) {
        if (typeof target['_inputFields'] == 'undefined') {
            target['_inputFields'] = {};
        }
        target['_inputFields'][propertyKey] = inputFieldOptions;
    }

}


export interface CopyPasteGroupOptions {
    groupId?: string;
}

export function CopyPasteGroup(copyPasteGroupOptions?: CopyPasteGroupOptions) {

    return function (target: Object, propertyKey: string | symbol) {
        if (typeof target['_cpGroup'] == 'undefined') {
            target['_cpGroup'] = {};
        }
        target['_cpGroup'][propertyKey] = copyPasteGroupOptions;
    }

}